module.exports = __webpack_public_path__ + "img/01.acb809bb.png";